import React from "react";

const WhatsInItForMeVideo = ({ subsection, saveProgress }) => {
  const about = (
    <div className="space-y-5 pt-2 pb-6 text-body leading-7 text-[#484848]">
      <p>
      This lesson shows why your updates get ignored even when the work is solid. Leaders and stakeholders operate with limited time and a simple question: what does this help me with right now. Most people communicate in effort and process, while stakeholders listen for benefits and outcomes. The shift is to do detective work on what they value, then translate your message into their language, like speed, risk, or money.
      </p>
    </div>
  );

  const transcriptHtml = `
    <p>Picture this: you're on a quiet beach. Waves rolling in. Breeze brushing your face. You've got that perfect "finally off the grid" moment… except your stomach is growling.</p>

    <p>Everyone's arguing about where to eat. You're hangry, restless, and the calm you came for is slipping away.</p>

    <p>Suddenly, your phone rings. It's from your team, you frown, knowing this isn't going to be a quick chat, but you pick it up anyway.</p>

    <p>"Sir, you won't believe it, I cracked the Project! It was difficult: 14 hour days, nights, weekends. Team was uncooperative, I skipped coffee, almost fainted… and don't even ask about the escalations"</p>

    <p>Five minutes in, you're still hungry, staring at the waves, thinking: <strong>I don't care.</strong></p>

    <p>You wanted lunch and peace, not really a Mount "Project" saga right?</p>

    <p>In the corporate world, the same thing happens every single day. Your leaders, clients, and stakeholders, they're all in <strong>beach mode</strong>. They have limited time, clear appetite, and simple goals.</p>

    <p>But most updates from you, show up in <strong>mountain mode</strong>:</p>
    <ul style="margin-left: 20px;">
      <li>"We worked 14 hours."</li>
      <li>"We fixed 42 bugs."</li>
      <li>"We coordinated with QA, Legal, and Ops."</li>
    </ul>

    <p>So… we just stop giving updates?</p>

    <p>No, do you see the mismatch between what you are giving and what they want?</p>

    <p>They're thinking, <strong>What's in it for me?</strong></p>

    <p>That's the <strong>golden rule of communication</strong></p>

    <p>People aren't ignoring you because they're mean. They're filtering everything through one lens: "Does this help me, right now?"</p>

    <p>Benefits are easier to digest than your effort or every single step you took. And when you start with their priorities, suddenly your priorities get airtime too.</p>

    <p>Your first job is <strong>detective work</strong>.</p>

    <p>Understand what your stakeholder really values.</p>

    <p><strong>How do we spot it?</strong></p>

    <p>Listen to their questions:</p>
    <p>If they ask "How soon can we launch?" Their priority is speed, not your process.</p>

    <p>Once you know their language, the job is to translate your update into it.</p>

    <p>Which means if you want to talk about speed</p>
    <p>Don't say "We improved deployment time."</p>
    <p>Say: "<strong>You get releases in 7 days, down from 10.</strong>"</p>

    <p>Because the moment your message carries what's in it for them, it lands.</p>
    <p>Smoothly. Right where it needs to.</p>

    <p>But does this work for everybody?</p>
    <p>Let's find out in the next video.
  `;

  const transcript = (
    <div
      className="pt-2 pb-6 text-body leading-7 text-[#484848] max-w-2xl"
      dangerouslySetInnerHTML={{ __html: transcriptHtml }}
    />
  );

  // const relatedLinks = (
  //   <div className="pt-2 pb-6">
  //     <ul className="list-disc list-inside text-body space-y-2">
  //       <li>
  //         <button type="button" className="text-link">
  //           Download Slides
  //         </button>
  //       </li>
  //       <li>
  //         <button type="button" className="text-link">
  //           Reference Reading: Career Transitions Report 2025
  //         </button>
  //       </li>
  //     </ul>
  //   </div>
  // );

  const notes = (
    <div className="pt-2 pb-6">
      <textarea
        rows={4}
        placeholder="Write your notes here..."
        className="w-full border border-gray-200 rounded-xl p-3 text-body focus:ring-2 focus:ring-brand/40 focus:outline-none"
        onBlur={(e) => saveProgress("in_progress", { notes: e.target.value })}
      />
    </div>
  );

  return { about, transcript, notes };
};

export default WhatsInItForMeVideo;